export var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');
//# sourceMappingURL=canUse.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/common/canUse.js
// module id = ./node_modules/@apollo/client/utilities/common/canUse.js
// module chunks = 54 55